import React from "react";
import { Link } from "react-router-dom";
import { Settings as SettingsIcon } from "lucide-react";

/**
 * Settings gear icon — mirrors the look of NotificationsBell.
 * Used only in the Super-Admin TopNav.
 */
export default function SettingsIconLink({ to = "/settings" }) {
  return (
    <Link
      to={to}
      className="topnav-bell"
      title="Settings"
      data-testid="settings-icon"
    >
      <SettingsIcon size={17} />
    </Link>
  );
}
